import kebabCase from 'lodash/kebabCase'
import React, { forwardRef } from 'react'

type IconButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  iconClass: string
  title?: string
  className?: string
  style?: React.CSSProperties
  id?: string
  disabled?: boolean
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ onClick, iconClass, title, className, style, id, disabled }, ref) => {
    const buttonId = id ? `btn-icon-${kebabCase(id)}` : undefined
    return (
      <button
        id={buttonId}
        type="button"
        title={title}
        className={`unstyled-button ${className}`}
        onClick={(event) => onClick(event)}
        ref={ref}
        style={style}
        disabled={disabled}
      >
        <i className={`${iconClass}`} />
      </button>
    )
  }
)

export default IconButton
